<template>
  <div class="mx-auto max-w-xl py-2">
    <div class="breadcrumbs mb-2">
      <NuxtLink :to="{ name: 'leagues' }">{{ $t('shared.nav.leagues') }}</NuxtLink>
    </div>
    <h1 class="font-heading font-bold text-2xl" v-html="$t('pages.leagues.heading')" />
    <div class="space-y-3 mt-4">
      <div v-for="league in data.leagues" :key="`league-${league.id}`" class="border rounded-md bg-white">
        <NuxtLink :to="{ name: 'leagues-league', params: { league: league.slug }}" class="p-2 block">
          <div class="flex items-center gap-3">
            <LeagueLogo class="w-12 lg:w-16 aspect-square rounded-md overflow-hidden" :name="league.name" :slug="league.slug" />
            <div>
              <div class="font-bold md:text-xl">{{ league.name }}</div>
              <div class="text-sm text-slate-500">{{ league.season.year }}</div>
            </div>
            <div class="ml-auto text-sky-600 p-1">
              <AtomIcon name="chevron-circle-right" class="text-xl" />
            </div>
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const { data } = useFetch('/api/v1/leagues', { 
  key: 'leagues',
  baseURL: useEnv('apiBase'),
})
</script>